import { Component } from "../component"
import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { deviceWidth } from "../helpers/device-size"

gsap.registerPlugin(ScrollTrigger)

export class BlogArticlePreview extends Component {
  constructor(props) {
    super(props)
  }

  ui() {
    return {
      leftImage: ".blog-article-preview-main-img",
      rightImage: ".blog-article-preview-right-img",
      tag: ".blog-article-preview-tag-desktop",
    }
  }

  animateElements() {
    const { leftImage, rightImage, tag } = this.$ui

    const deviceType = deviceWidth()

    if (deviceType === "PHONE" || deviceType === "TABLET") {
      return
    }

    gsap.from([leftImage, rightImage], {
      y: 200,
      duration: 1.5,
      ease: "power2.inOut",
      scrollTrigger: {
        trigger: tag,
        start: "top-=110 bottom",
        onLeave: () => {
          gsap.set(leftImage, { y: 0 })
          gsap.set(rightImage, { y: 0 })
        },
        onLeaveBack: () => {
          gsap.set(leftImage, { y: 0 })
          gsap.set(rightImage, { y: 0 })
        },
      },
    })
  }

  created() {
    this.animateElements()
  }
}
